import React, { useEffect, useRef, useState } from "react";
import { sections } from "../../data/data";
import SubMenu from "./SubMenu";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface NavigationTabsProps extends React.HTMLAttributes<HTMLUListElement> {
  id?: string;
  variant?: string;
}

const NavigationMenu = ({ variant, ...props }: NavigationTabsProps) => {
  const [selectedItemId, setSelectedItemId] = useState<string | null>("1");
  const { t } = useTranslation();
  const menuRef = useRef<HTMLUListElement>(null);
  const [isExpanded, setIsExpanded] = useState<string | null>("1");

  const handleItemClick = (id: string) => {
    if (selectedItemId === id) {
      setIsExpanded((prev) => (prev === id ? null : id));
      setTimeout(() => {
        setSelectedItemId(null);
      }, 100);
    } else {
      setSelectedItemId(id);
      setIsExpanded(id);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setSelectedItemId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //show sub menu when hover on item
  const handleMouseHover = (id: string) => {
    setSelectedItemId(id);
    setIsExpanded(id);
  };
  const handleMouseleave = () => {
    setSelectedItemId(null);
    setIsExpanded(null);
  };
const navigate=useNavigate();
  return (
    <ul
      ref={menuRef}
      {...props}
      className={`takaful--navigation-menu-list ${props.className ?? ""}`}
    >
      {sections.map((section) => (
        <div
          key={section.id}
          className={`takaful--list-item ${
            variant === "homePage" ? "text-color" : "text-color-white"
          } ${section.id === selectedItemId ? "selected-item " : ""}`}
          onClick={() => handleItemClick(section.id)}
          onMouseEnter={() => handleMouseHover(section.id)}
        >
          {section.link && !section.subList?.length ? (
            <span onClick={() => navigate(section.link)}>{t(section.label)}</span>
          ) : (
            t(section.label)
          )}
          {section.subList &&
            section.subList.length > 0 &&
            section.id === selectedItemId && (
              <SubMenu
                items={section.subList}
                handleMouseHover={() => handleMouseHover(section.id)}
                handleMouseleave={handleMouseleave}
                className={isExpanded === section.id ? "expanded" : "collapsed"}
              />
            )}
        </div>
      ))}
    </ul>
  );
};

export default NavigationMenu;
